import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { HUB_API_SETTINGS_TOKEN } from '../../hub-api-settings-token';
import { HubApiSettingsService } from '../../hub-api-settings.service';

import { CreateStaffNoAccessCommand } from '../model/command/create-staff-no-access-command';
import { EditStaffNoAccessCommand } from '../model/command/edit-staff-no-access-command';
import { CreateStaffCommand } from '../model/command/create-staff-command';
import { DeleteStaffCommand } from '../model/command/delete-staff-command';
import { EditStaffCommand } from '../model/command/edit-staff-command';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

// Generated service for sending Staff commands to the API.
@Injectable()
export class StaffCommandService {

  constructor(
    private http: HttpClient,
    private settingsService: HubApiSettingsService,
  ) { }

  CreateStaffNoAccessCommand(commandData: CreateStaffNoAccessCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Staff.CreateStaffNoAccessCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditStaffNoAccessCommand(commandData: EditStaffNoAccessCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Staff.EditStaffNoAccessCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  CreateStaffCommand(commandData: CreateStaffCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Staff.CreateStaffCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  DeleteStaffCommand(commandData: DeleteStaffCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Staff.DeleteStaffCommand'
      },
    };
    return this.http.request('POST', url, options);
  }

  EditStaffCommand(commandData: EditStaffCommand): Observable<any> {
    const token = this.settingsService.getAccessToken();
    const url = `${this.settingsService.getApiServiceBaseUrl()}webCommand/processWebCommand`;
    const options = {
       headers: new HttpHeaders(
        {
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Bearer ${token}`
        }),
      body: {
        'CommandData': JSON.stringify(commandData),
        'CommandType': 'Cads.SmartScaffolder.Hub.Business.Commands.Staff.EditStaffCommand'
      },
    };
    return this.http.request('POST', url, options);
  }
}
